import { API } from 'aws-amplify';

const addChallengeApi = async (body: any) => {
	return API.post(process.env.REACT_APP_NAME || '', '/challenges', { body });
};

const getSignedUrlApi = async (body: any) => {
	return API.post(process.env.REACT_APP_NAME || '', '/s3', { body });
};

export { addChallengeApi, getSignedUrlApi };
